import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Shell from "@/components/Shell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Customers from "@/pages/Customers";
import Invoices from "@/pages/Invoices";
import InvoiceCreate from "@/pages/InvoiceCreate";
import InvoiceView from "@/pages/InvoiceView";
import Returns from "@/pages/Returns";
import ReturnCreate from "@/pages/ReturnCreate";
import ReturnView from "@/pages/ReturnView";
import ReturnEdit from "@/pages/ReturnEdit";
import InvoiceEdit from "@/pages/InvoiceEdit";
import StyleSalesHistory from "@/pages/StyleSalesHistory";
import ProductActivityLog from "@/pages/ProductActivityLog";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40 }} data-testid="auth-loading">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Shell>{children}</Shell>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ padding: 40 }}>Loading...</div>;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/products" element={<Protected><Products /></Protected>} />
          <Route path="/customers" element={<Protected><Customers /></Protected>} />
          <Route path="/invoices" element={<Protected><Invoices /></Protected>} />
          <Route path="/invoices/new" element={<Protected><InvoiceCreate /></Protected>} />
          <Route path="/invoices/:id" element={<Protected><InvoiceView /></Protected>} />
          <Route path="/invoices/:id/edit" element={<Protected><InvoiceEdit /></Protected>} />
          <Route path="/returns" element={<Protected><Returns /></Protected>} />
          <Route path="/returns/new" element={<Protected><ReturnCreate /></Protected>} />
          <Route path="/returns/:id" element={<Protected><ReturnView /></Protected>} />
          <Route path="/returns/:id/edit" element={<Protected><ReturnEdit /></Protected>} />
          <Route path="/reports/style-sales" element={<Protected><StyleSalesHistory /></Protected>} />
          <Route path="/products/:id/activity" element={<Protected><ProductActivityLog /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
